import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ticketApi } from "../apis/ticketApi";

/**
 * Hook to resolve `currentApiPos` from:
 * 1. localStorage (fastest, set when user clicks a brand on HomePage)
 * 2. API fetch by brandId (when accessing page directly via URL)
 * 3. Fallback: window.env.REACT_DEFAULT_APP_BASE_URL
 */
const useCurrentApiPos = () => {
  const [apiPos, setApiPos] = useState(
    () => localStorage.getItem("currentApiPos") || "",
  );
  const [params] = useSearchParams();
  const brandId = params.get("brandId");

  useEffect(() => {
    // Already have it in localStorage — nothing to do
    if (localStorage.getItem("currentApiPos")) return;

    // No brandId in URL — use the default base URL as fallback
    if (!brandId) {
      setApiPos(window.env.REACT_DEFAULT_APP_BASE_URL);
      return;
    }

    // Fetch branch list to find apiPos for this brandId
    (async () => {
      try {
        const res = await ticketApi.getListBranch(
          window.env.REACT_DEFAULT_APP_BASE_URL,
        );
        const branches = res?.data || [];
        const match = branches.find(
          (b) => b.maChiNhanh?.toLowerCase() === brandId.trim().toLowerCase(),
        );
        const resolved = match?.apiPos || window.env.REACT_DEFAULT_APP_BASE_URL;
        localStorage.setItem("currentApiPos", resolved);
        setApiPos(resolved);
      } catch {
        setApiPos(window.env.REACT_DEFAULT_APP_BASE_URL);
      }
    })();
  }, [brandId]);

  return apiPos || window.env.REACT_DEFAULT_APP_BASE_URL;
};

export default useCurrentApiPos;
